import AppTd from "@/components/AppTd";
export default {
  name: 'SeoAPlusCell',
  props: {
    item: Object
  },
  components: {
    AppTd
  }
};